export default __webpack_public_path__ + "static/media/room-2Bed-double-F.9ee08f87.jpg";